import styled from 'styled-components';

export const Container = styled.div`
  margin: 0 auto;
  width: 604px;
  border: 1px solid black;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 16px;
  background-color: rgb(240, 240, 240);
`;

export const TitleWrapper = styled.div`
  font-size: 24px;
  display: flex;
  align-items: center;
  width: 345px;
  padding: 8px 0;
  font-weight: 500;
`;

export const ImageWrapper = styled.div`
  padding: 8px 0;
`;

export const BodyWrapper = styled.div``;

export const ContentWrapper = styled.div`
  height: 100%;
  width: 520px;
  margin: 0 auto;
`;

export const TextWrapper = styled.div`
  padding: 40px 24px;
`;
